"use client";

import { UseFormReturn } from "react-hook-form";

import FormRootError from "@/components/shared/form/form-root-error";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Form, FormControl, FormField, FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";

export type SaveSearchFormValues = { name: string };

export function SaveSearchModalView({
  open,
  onClose,
  form,
  autoname,
  isSaving,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  form: UseFormReturn<SaveSearchFormValues>;
  autoname: string;
  isSaving: boolean;
  onSubmit: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Save these filters</DialogTitle>
        </DialogHeader>

        <Form {...form}>
          <form onSubmit={onSubmit}>
            <div className="flex flex-col gap-4 pt-1">
              <FormField
                control={form.control}
                name="name"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Input
                        placeholder={autoname}
                        aria-label="Search name"
                        className="text-base font-medium h-10 border-line-light focus-visible:border-line-strong"
                        data-testid="save-search-name-input"
                        {...field}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />

              <FormRootError />
            </div>

            <DialogFooter className="pt-5">
              <Button
                type="button"
                variant="outline"
                onClick={onClose}
                disabled={isSaving}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={isSaving}
                data-testid="save-search-confirm"
              >
                {isSaving ? "Saving…" : "Save search"}
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
}
